import React from 'react';
import { useContactForm } from './ContactPage.logic';
import ContactPageView from './ContactPage.view';

const ContactPage = () => {
  const { formData, handleChange, handleSubmit, companySizes, countries } = useContactForm();
  
  return (
    <ContactPageView 
      formData={formData}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      companySizes={companySizes}
      countries={countries}
    />
  );
};

export default ContactPage; 